import Button from '@atlaskit/button';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalTitle,
    ModalFooter,
    ModalTransition,
} from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives';

interface EmailUpdateModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const EmailUpdateModal = ({ isOpen, onConfirm, onCancel }: EmailUpdateModalProps) => {
    return (
        <ModalTransition>
            {isOpen && (
                <Modal onClose={onCancel}>
                    <ModalHeader>
                        <ModalTitle>Update bot account</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <Box>
                            <p>Your bot account details will be updated with the new one.</p>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Box style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'flex-end'
                        }}>
                            <Button appearance="subtle" onClick={onCancel}>
                                Cancel
                            </Button>
                            <Button appearance="warning" onClick={onConfirm}>
                                Continue
                            </Button>
                        </Box>
                    </ModalFooter>
                </Modal>
            )}
        </ModalTransition>
    );
}; 